import { MicrophoneInfo, WifiInfo } from "@core/ability";

function sortByIsDefault<T extends { isDefault?: boolean }>(arr: T[]): T[] {
  return arr.sort((a, b) => {
    if (a.isDefault && !b.isDefault) return -1;
    if (!a.isDefault && b.isDefault) return 1;
    return 0;
  });
}
export function formatMicList(micList: MicrophoneInfo[]) {
  const filterList = micList.map((item) => {
    return {
      deviceId: item.id,
      label: item.isDefault ? "系统默认" : item.desc,
      isDefault: item.isDefault,
    };
  });
  return sortByIsDefault(filterList);
}

export function formatCustomDeviceInfo(wifiInfo: WifiInfo) {
  return {
    key: wifiInfo.bssid,
    name: wifiInfo.deviceName,
    code: wifiInfo.pinCode,
    type: 'ifpd',
    extra: wifiInfo,
  }
}
